import { defineComponent, ref, inject, computed, onMounted, onBeforeUnmount, watch } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "OptionPC",
  props: {
    label: null,
    value: { type: [String, Number, Boolean, Object] },
    customOptionContentStyle: null
  },
  setup(__props) {
    const props = __props;
    const optionRef = ref(null);
    const select = inject("select");
    const isSelected = computed(
      () => select && select.selectedValue === props.value
    );
    const optionData = computed(() => ({
      label: props.label,
      value: props.value,
      ref: optionRef
    }));
    onMounted(() => {
      select == null ? void 0 : select.onOptionCreated(optionData.value);
    });
    onBeforeUnmount(() => {
      select == null ? void 0 : select.onOptionDestroyed(props.value);
    });
    watch(
      () => [props.value, props.label],
      (val, oldVal) => {
        if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
          select == null ? void 0 : select.onOptionDestroyed(oldVal);
          select == null ? void 0 : select.onOptionCreated(optionData.value);
        }
      }
    );
    function handleChooseOption() {
      select == null ? void 0 : select.onOptionSelected(optionData.value);
    }
    return { __sfc: true, optionRef, props, select, isSelected, optionData, handleChooseOption };
  }
});
export {
  _sfc_main as default
};
